import { openVideoWindow } from './videoWindow';

let videoPopupRef: Window | null = null;
let avatarPopupRef: Window | null = null;

const buildAvatarPopupUrl = (): string => {
  const url = new URL(window.location.href);
  url.searchParams.set('popup', 'avatar');
  return url.toString();
};

const openAvatarPopupWindow = (features?: string): Window | null => {
  const defaultFeatures =
    'width=800,height=600,menubar=no,toolbar=no,location=no,scrollbars=no,resizable=yes';
  return window.open(
    buildAvatarPopupUrl(),
    'avatarDisplay',
    features || defaultFeatures
  );
};

const buildHalfScreenFeatures = (side: 'left' | 'right'): string => {
  const screenInfo = window.screen as Screen & {
    availLeft?: number;
    availTop?: number;
  };
  const availW = screenInfo.availWidth;
  const availH = screenInfo.availHeight;
  const left = screenInfo.availLeft ?? 0;
  const top = screenInfo.availTop ?? 0;
  const halfW = Math.max(480, Math.floor(availW / 2));
  const x = side === 'left' ? left : left + halfW;

  return [
    `left=${x}`,
    `top=${top}`,
    `width=${halfW}`,
    `height=${availH}`,
    'menubar=no',
    'toolbar=no',
    'location=no',
    'scrollbars=no',
    'resizable=yes',
  ].join(',');
};

export function openSplitWindows(): {
  video: Window | null;
  avatar: Window | null;
} {
  const videoFeatures = buildHalfScreenFeatures('left');
  const avatarFeatures = buildHalfScreenFeatures('right');

  const video = openVideoWindow(videoFeatures);
  const avatar = openAvatarPopupWindow(avatarFeatures);

  if (!video || !avatar) {
    if (video && !video.closed) {
      video.close();
    }
    if (avatar && !avatar.closed) {
      avatar.close();
    }
    videoPopupRef = null;
    avatarPopupRef = null;
    return { video: null, avatar: null };
  }

  videoPopupRef = video;
  avatarPopupRef = avatar;
  return { video, avatar };
}

export function closeSplitWindows(): void {
  if (videoPopupRef && !videoPopupRef.closed) {
    videoPopupRef.close();
  }
  if (avatarPopupRef && !avatarPopupRef.closed) {
    avatarPopupRef.close();
  }
  videoPopupRef = null;
  avatarPopupRef = null;
}

export function isSplitWindowsActive(): boolean {
  const videoOpen = !!(videoPopupRef && !videoPopupRef.closed);
  const avatarOpen = !!(avatarPopupRef && !avatarPopupRef.closed);
  return videoOpen || avatarOpen;
}

export function areBothSplitWindowsOpen(): boolean {
  return (
    !!(videoPopupRef && !videoPopupRef.closed) &&
    !!(avatarPopupRef && !avatarPopupRef.closed)
  );
}
